import { Organisation } from "./Organisation";

export const ROLES = ["admin", "manager", "basic"] as const;
export type Role = (typeof ROLES)[number];

export class User {
    organisationId: string;
    username: string;
    email: string;
    joinedAt: number;
    groupIds: string[];

    constructor(init: Partial<User>) {
        Object.assign(this, init);
        this.groupIds = init.groupIds || [];
    }

    static can(permissions: Permission[], action: PermissionAction, subject: string): boolean {
        return permissions.some((permission) => permission.actions.includes(action) && permission.subject === subject);
    }

    isAdmin(): boolean {
        return this.groupIds.includes("Gmt2vHwrYRpr");
    }

    isManager(): boolean {
        return this.groupIds.includes(Organisation.createOrganisationManagerGroupId(this.organisationId));
    }
}

export class UserGroup {
    organisationId: string;
    name: string;
    groupId: string;
    description: string;
    createdAt: number;
    createdBy: string;
    modifiedAt: number;
    permissions: Permission[];
    isAdmin: boolean;
    isManager: boolean;
    isBasic: boolean;
}

export type PermissionAction = "create" | "read" | "update" | "delete" | "execute" | "manage" | "peek";
export type PermissionSubject = "users" | "groups" | "projects" | "media" | "files" | "orgs" | "settings";

export class Permission {
    permissionId: string;
    target: PermissionTarget; // This is the user or group ID that this permission applies to
    actions: PermissionAction[];
    subject: PermissionSubject;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition?: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(actions: PermissionAction[], subject: PermissionSubject, target: PermissionTarget, condition?: any) {
        this.actions = actions;
        this.subject = subject;
        this.target = target;
        this.condition = condition;
    }
}

export class PermissionTarget {
    targetId: string;
    type: "user" | "group";

    constructor(targetId: string, type: "user" | "group") {
        this.targetId = targetId;
        this.type = type;
    }

    static forGroup(groupId: string): PermissionTarget {
        return new PermissionTarget(groupId, "group");
    }

    static forUser(userId: string): PermissionTarget {
        return new PermissionTarget(userId, "user");
    }
}

export interface ResourcePermissionRequest {
    groups: { [key: string]: PermissionAction[] };
    users: { [key: string]: PermissionAction[] };
}
